import { parse } from "../utils";
export default {
  "post|library/pickup": (option) => {
    const pageSize = parse("pageSize", option.url);
    let list = [
      {
        id: "1",
        link: "/research/detail",
        // link: "/library/casestudy/detail",
        cover: require("@/assets/images/c02-01-1.png"),
        title: "サイバー人材需給逼迫1",
        catagory: "トレンド",
        publicDate: "2021-07-20T00:00:00+00:00",
        // updateDate: "0001-01-01T00:00:00",
        // updateDate: null,
        updateDate: "2021-07-21T00:00:00+00:00",
        libraryType: "page",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒ.",
      },
      {
        id: "2",
        cover: require("@/assets/images/c02-01-2.png"),
        link: require("@/assets/images/temp.pdf"),
        libraryType: "pdf",
        title: "サイバー人材需給逼迫2",
        catagory: "ピックアップニュース",
        publicDate: "2021-07-19T00:00:00+00:00",
        updateDate: "2021-07-20T00:00:00+00:00",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
      },
      {
        id: "3",
        cover: require("@/assets/images/c02-01-3.png"),
        link: "http://www.baidu.com",
        title: "サイバー人材需給逼迫3",
        libraryType: "link",
        catagory: "トレンド",
        publicDate: "2020-01-01 09:12:08",
        updateDate: "2020-01-01 09:12:08",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
      },
      {
        id: "4",
        cover: require("@/assets/images/c02-01-4.png"),
        link: require("@/assets/images/temp.pdf"),
        libraryType: "pdf",
        title: "サイバー人材需給逼迫4",
        catagory: "トレンド",
        publicDate: "2020-01-01 09:12:08",
        updateDate: "2020-01-01 09:12:08",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
      },
      {
        id: "5",
        cover: require("@/assets/images/c02-01-5.png"),
        link: "/library/casestudy/detail",
        title: "サイバー人材需給逼迫5",
        libraryType: "page",
        catagory: "トレンド",
        publicDate: "2020-01-01 09:12:08",
        updateDate: "2020-01-01 09:12:08",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
      },
      {
        id: "6",
        cover: require("@/assets/images/c02-01-6.png"),
        link: "/research/detail",
        title: "サイバー人材需給逼迫6",
        libraryType: "page",
        catagory: "トレンド",
        publicDate: "2020-01-01 09:12:08",
        updateDate: "2020-01-01 09:12:08",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
      },
      {
        id: "7",
        cover: require("@/assets/images/c02-01-7.png"),
        link: "/research/detail",
        libraryType: "page",
        title: "サイバー人材需給逼迫7",
        catagory: "ピックアップニュース",
        publicDate: "2020-01-01 09:12:08",
        updateDate: "2020-01-01 09:12:08",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
      },
      {
        id: "8",
        cover: require("@/assets/images/c02-01-8.png"),
        link: "/research/detail",
        libraryType: "page",
        title: "サイバー人材需給逼迫8",
        catagory: "トレンド",
        publicDate: "2020-01-01 09:12:08",
        updateDate: "2020-01-01 09:12:08",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
      },
      {
        id: "9",
        cover: require("@/assets/images/c02-01-9.png"),
        link: "/research/detail",
        libraryType: "page",
        title: "サイバー人材需給逼迫9",
        catagory: "トレンド",
        publicDate: "2020-01-01 09:12:08",
        updateDate: "2020-01-01 09:12:08",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
      },
      {
        id: "10",
        cover: require("@/assets/images/c03-02-1.png"),
        link: "/research/detail",
        libraryType: "page",
        title: "サイバー人材需給逼迫10",
        catagory: "トレンド",
        publicDate: "2020-01-01 09:12:08",
        updateDate: "2020-01-01 09:12:08",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
      },
    ];

    if (pageSize) {
      list = list.slice(0, Number(pageSize));
    }

    return {
      code: 200,
      msg: "操作成功",
      data: {
        totalCount: 40,
        list: list,
      },
    };
  },
};
